module.exports = __webpack_public_path__ + "pie.png?eb9acda1b539f8ea041719afee2435ad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pie.png
// module id = 38
// module chunks = 0